Accounts = require 'common/lib/accounts'
BillingHistoryComponent = require './billing-history-component'
CancelFlowComponent = require './cancel-flow-component'
CreditCardFormComponent = require './credit-card-form-component'
TaxExemptionComponent = require './form-sections/tax-exemption-component'
OrgFeatures = require 'data/org-features'
Promise = require 'bluebird'
React = require 'react'
TFM = require 'lib/markdown/tfm'
WithSalesTax = require './with-sales-tax'
t = require('views/internal/recup-with-helpers')('billing')
f = require 'effing'
l = require 'lib/localize'
localizeCount = require 'lib/localize-count'
track = require 'debug/track'
_ = require 'underscore'
xtend = require 'xtend'
$ = require 'jquery'
partialComponent = require 'lib/react/partial-component'
formatMoney = require 'lib/format/money'

module.exports = class extends React.Component
  displayName: 'BillingComponent'

  constructor: (props) ->
    super(props)

    @state = {
      processingReactivation: false
      reactivateDisabled: false
      reactivatingProduct: null
    }

  withSalesTax: (subtotals, renderContents) ->
    t.createElement WithSalesTax,
      salesTaxForSubscriberUrl: @props.salesTaxForSubscriberUrl
      nextBillingDate: @props.paidAccount.nextBillingDate
      dateStandingChanged: @props.paidAccount.dateStandingChanged
      subtotals: subtotals
      renderContents: renderContents
      renderError: -> t.format 'could-not-calculate-sales-tax'
      renderLoading: -> t.span '.spinner.loading'

  render: t.renderable ->
    {
      activeAccount,
      canSwitchToYearly,
      cancelledAccount,
      certCaptureTokenUrl,
      hasAccount,
      id,
      nextBillingDate,
      nextChargeAmount,
      paidAccount,
      problemAccount,
      productName,
      statementUrl,
      willExpire
    } = @props
    { justCancelled, processingReactivation } = @state

    t.div =>
      @renderStatusBanner()

      if activeAccount
        t.div '.window-module.u-text-align-center', =>
          t.div '.u-gutter', =>

            if willExpire
              @renderExpirationAndRenewButton()
            else
              if paidAccount.cardType
                if nextChargeAmount && nextBillingDate
                  @renderNextCharge()

                if canSwitchToYearly()
                  @renderUpgradeToYearly()

              else
                @renderCreditExpirationMessage()

      # render billing form below credit expiration message but
      # outside of the u-text-align-center wrapping div
      if activeAccount && !willExpire && !paidAccount.cardType && !problemAccount
        @renderBillingForm()

      if cancelledAccount && !processingReactivation
        @renderReactivateSection()

      if paidAccount.cardType
        if activeAccount
          @renderPaymentMethod()

        @renderBillingContact()

        t.createElement TaxExemptionComponent, { certCaptureTokenUrl, paidAccount, statementUrl }

        @renderAdditionalInvoiceDetails()

      if hasAccount
        t.createElement BillingHistoryComponent, { statementUrl, key: id }

      if activeAccount
        @renderCancelFlow(willExpire)

      if justCancelled
        t.div '.window-module', ->
          t.div '.u-gutter', ->
            t.p ->
              t.strong ->
                t.format 'your-productname-subscription-has-been-cancelled', { productName }

            t.p ->
              t.format 'well-keep-your-data-safe-and-your-account-will-remain-usable-if-youd-like-you-can-reinstate-productname-at-any-time-by-re-entering-your-credit-card-information', { productName }

            t.p ->
              t.format 'the-trello-team'

  renderNextCharge: =>
    { billingStrategy, nextChargeAmount, price, nextBillingDate } = @props

    t.p '.next-charge', =>
      if billingStrategy.perUser
        @withSalesTax [nextChargeAmount, price], ([nextChargeAmountTax, priceTax]) ->
          t.format (if priceTax then 'you-will-be-billed-nextchargeamount-price-plus-tax-per-billablemembercount-members-on-nextbillingdate' else 'you-will-be-billed-nextchargeamount-price-per-billablemembercount-members-on-nextbillingdate'),
            nextChargeAmount: formatMoney nextChargeAmount + nextChargeAmountTax
            price: formatMoney price
            tax: formatMoney priceTax
            billableMemberCount: localizeCount 'members', billingStrategy.userCount
            nextBillingDate: nextBillingDate
      else
        @withSalesTax [nextChargeAmount], ([nextChargeAmountTax]) ->
          t.format 'you-will-be-billed-nextchargeamount-on-nextbillingdate',
            nextChargeAmount: formatMoney nextChargeAmount + nextChargeAmountTax
            nextBillingDate: nextBillingDate

  renderUpgradeToYearly: =>
    { yearlyEquivalentPrice, yearlyEquivalentTotalPrice, billingStrategy, yearlyDiscountPercent, onSwitchToYearly } = @props

    t.p ->
      t.b onSwitchToYearly, '.button-link.mod-inline-block', style: { paddingLeft: '24px', paddingRight: '24px' }, ->
        t.format 'switch-to-yearly-billing'
    t.p =>
      if billingStrategy.perUser
        @withSalesTax [yearlyEquivalentTotalPrice, yearlyEquivalentPrice], ([yearlyEquivalentTotalPriceTax, yearlyEquivalentPriceTax]) ->
          t.format (if yearlyEquivalentPriceTax then 'yearly-billing-will-be-totalyearlyprice-yearlyprice-plus-tax-per-member-per-year' else 'yearly-billing-will-be-totalyearlyprice-yearlyprice-per-member-per-year'),
            totalYearlyPrice: formatMoney yearlyEquivalentTotalPrice + yearlyEquivalentTotalPriceTax
            yearlyPrice: formatMoney yearlyEquivalentPrice
            yearlyTax: formatMoney yearlyEquivalentPriceTax
      else
        @withSalesTax [yearlyEquivalentPrice], ([yearlyEquivalentPriceTax]) ->
          t.format 'yearly-billing-will-be-yearlyprice-per-year', yearlyPrice: formatMoney yearlyEquivalentPrice + yearlyEquivalentPriceTax
      t.br()
      t.format 'thats-percent-less-than-monthly-billing', { yearlyDiscountPercent }

  renderCreditExpirationMessage: =>
    { nextBillingDate } = @props

    t.p '.next-charge', ->
      t.format 'your-credits-will-expire-on-nextbillingdate', { nextBillingDate }
    t.p ->
      t.format 'keep-using-trello-in-style-even-after-your-credits-expire'

  renderExpirationAndRenewButton: =>
    { productName, expirationDate, onRenewClick } = @props

    renew = (args...) =>
      onRenewClick(args...).then => @setState justCancelled: false

    t.p '.quiet', ->
      t.format 'youve-cancelled-productname-but-you-can-use-the-premium-features-until-expirationdate', { productName, expirationDate }
    t.p ->
      t.b renew, '.button-link.mod-inline-block', style: { paddingLeft: '24px', paddingRight: '24px' }, ->
        t.format 'renew-your-subscription'
    t.p '.quiet', ->
      t.format 'when-you-renew-you-wont-be-charged-until-the-date-listed-above'

  renderBillingForm: =>
    { current, paidAccount, paidAccountPoll, createPaidAccount, didntGetAuthStatus, didGetAuthStatus, productName } = @props

    t.div '.billing', =>
      t.createElement CreditCardFormComponent,
        productName: productName
        defaultProduct: current.yearly.productNumber
        monthlyProduct: current.monthly
        yearlyProduct: current.yearly
        billingStrategy: current.billingStrategy
        onSubmit: createPaidAccount
        doPoll: paidAccountPoll
        buttonKey: 'continue'
        extraData:
          billingContactFullName: paidAccount.contactFullName
          billingContactEmail: paidAccount.contactEmail
          billingContactLocale: paidAccount.contactLocale
        didntGetAuthStatus: ->
          didntGetAuthStatus()
        didGetAuthStatus: ->
          didGetAuthStatus()

  renderReactivationButtons: =>
    { current, productName } = @props
    { reactivateDisabled } = @state

    reactivateMonthly = f(@, 'reactivate', current.monthly.productNumber)
    reactivateYearly = f(@, 'reactivate', current.yearly.productNumber)

    t.div '.window-module', =>
      t.div '.window-module-title', ->
        t.h3 ->
          t.format 'reactivate-productname', { productName }

      t.div '.u-gutter', =>

        t.div '.billing-option-buttons.u-clearfix', =>

          t.b reactivateMonthly, class: t.classify(disabled: reactivateDisabled), =>
            t.span '.name', ->
              t.format 'charge-monthly'
            t.span '.price', =>
              if current.billingStrategy.perUser
                @withSalesTax [current.monthly.price, current.monthly.totalPrice], ([currentMonthlyPriceTax, currentMonthlyTotalPriceTax]) ->
                  t.format (if currentMonthlyPriceTax then 'totalmonthlyprice-monthlyprice-plus-tax-per-member' else 'totalmonthlyprice-monthlyprice-per-member'),
                    totalMonthlyPrice: formatMoney current.monthly.totalPrice + currentMonthlyTotalPriceTax
                    monthlyPrice: formatMoney current.monthly.price
                    monthlyTax: formatMoney currentMonthlyPriceTax
              else
                @withSalesTax [current.monthly.price], ([currentMonthlyPriceTax]) ->
                  t.strong ->
                    t.format 'monthlyprice', monthlyPrice: formatMoney current.monthly.price + currentMonthlyPriceTax
                return

          t.b reactivateYearly, class: t.classify(disabled: reactivateDisabled), =>
            t.span '.name', ->
              t.format 'charge-yearly-save'
            t.span '.price', =>
              if current.billingStrategy.perUser
                @withSalesTax [current.yearly.price, current.yearly.totalPrice], ([currentYearlyPriceTax, currentYearlyTotalPriceTax]) ->
                  t.format (if currentYearlyPriceTax then 'totalyearlyprice-yearlyprice-plus-tax-per-member' else 'totalyearlyprice-yearlyprice-per-member'),
                    totalYearlyPrice: formatMoney current.yearly.totalPrice + currentYearlyTotalPriceTax
                    yearlyPrice: formatMoney current.yearly.price
                    yearlyTax: formatMoney currentYearlyPriceTax
              else
                @withSalesTax [current.yearly.price], ([currentYearlyPriceTax]) ->
                  t.strong ->
                    t.format 'yearlyprice', yearlyPrice: formatMoney current.yearly.price + currentYearlyPriceTax
              return

  renderReactivateSection: =>
    { paidAccount } = @props

    if paidAccount.cardType?
      # we have a card on file,
      # so doesnt need a form,
      # just show reactivate buttons
      @renderReactivationButtons()
    else
      # we dont have a card on file,
      # so we'll need to show the billing form,
      # which now includes monthly/yearly buttons
      @renderBillingForm()

  renderPaymentMethod: =>
    { accountStanding, accountStandingDisplay, paidAccount, onClickChangeCC } = @props

    t.div '.window-module', =>
      t.div '.window-module-title', ->
        t.h3 '.u-inline', ->
          t.format 'payment-method'

      t.div '.u-gutter', ->
        t.p ->
          if accountStanding == 'good'
            t.format 'your-account-is-in-good-standing'
          else
            t.format 'account-standing-accountstandingdisplay', { accountStandingDisplay }

          t.br()

          t.format 'credit-card-on-file'
          t.text ' '
          t.format 'paidaccount-cardlast4', { paidAccount_cardLast4: paidAccount.cardLast4 }
          t.text ' '
          t.b onClickChangeCC, '.quiet', ->
            t.format 'change'

  reactivate: (productNumber) ->
    { reactivateProduct } = @props
    { reactivateDisabled } = @state

    if reactivateDisabled
      return

    productCycle =
      if OrgFeatures.isMonthly(productNumber)
        "Monthly"
      else
        "Yearly"

    track("Organization View", "Billing Page", "Reactivate Business Class - #{ productCycle }")

    @setState reactivateDisabled: true

    reactivateProduct(productNumber)
    .then (res) =>
      track("Organization", "Sucessfully Reactivate Business Class - #{ productCycle }")
      @setState processingReactivation: true, reactivateDisabled: false
    .done()

    return

  renderBillingContact: =>
    { paidAccount, onChangeBillingContactClick } = @props

    t.div '.window-module', ->
      t.div '.window-module-title', ->
        t.h3 ->
          t.format 'billing-contact'
      t.div '.u-gutter', ->
        t.p ->
          t.format 'paidaccount-contactfullname-paidaccount-contactemail', { paidAccount_contactFullName: paidAccount.contactFullName, paidAccount_contactEmail: paidAccount.contactEmail }
          t.text ' '
          t.b onChangeBillingContactClick, '.quiet', ->
            t.format 'change'

  renderAdditionalInvoiceDetails: =>
    { paidAccount, onChangeAdditionalDetailsClick } = @props

    t.div '.window-module', ->
      t.div '.window-module-title', ->
        t.h3 ->
          t.format 'additional-invoice-details'
      t.div '.u-gutter', ->
        if paidAccount.invoiceDetails
          t.raw TFM.description.format(paidAccount.invoiceDetails).output
          t.div ->
            t.b onChangeAdditionalDetailsClick, '.quiet', ->
              t.format 'change'
        else
          t.p ->
            t.format 'we-dont-have-any-additional-information-for-your-invoice'
            t.text ' '
            t.b onChangeAdditionalDetailsClick, '.quiet', ->
              t.format 'change'

  renderCancelFlow: (willExpire) =>
    { productName, cancelProduct } = @props

    t.createElement CancelFlowComponent,
      type: @props.type
      isModule: true
      productName: productName
      willExpire: willExpire
      id: @props.id
      cancelProduct: (args...) =>
        cancelProduct(args...)
        .then f.choke(0, f(@, 'setState', justCancelled: true))

  renderStatusBanner: =>
    { activeAccount, problemAccount, processingAccount, productIconClass, detailsUrl, productName, cancelledAccount, needCC, onClickChangeCC } = @props
    { processingReactivation } = @state

    t.div '.window-module.u-gutter', ->

      if activeAccount
        if problemAccount
          t.p '.bc-active-status.error', ->
            t.format 'theres-an-issue-with-productname', { productIconClass, detailsUrl, productName }
          t.b onClickChangeCC, '.emphasis-button', ->
            t.format 'you-are-overdue-and-we-are-having-trouble-processing-your-credit-card-enter-a-credit-card-to-resolve-the-issue'
        else
          t.p class: t.classify('bc-active-status': true, active: true, warning: processingAccount), ->
            t.span class: 'icon-lg icon-' + productIconClass
            if processingAccount
              t.format 'productname-is-almost-active', { detailsUrl, productName }
            else
              t.format 'productname-is-active', { detailsUrl, productName }

          if processingAccount
            t.p '.quiet', { style: { marginLeft: '46px' } }, ->
              t.format 'your-credit-card-is-being-processed'

      if cancelledAccount

        if processingReactivation
          t.p '.bc-active-status.warning', ->
            t.format 'your-account-is-being-processed-for-reactivation', { productIconClass }
          t.p '.quiet.u-text-align-center', ->
            t.format 'check-back-soon'
        else
          t.p '.bc-active-status.error', ->
            t.format 'productname-is-cancelled', { productIconClass, detailsUrl, productName }

      if needCC
        t.p '.bc-active-status.error', ->
          t.format 'productname-is-not-active', { productIconClass, detailsUrl, productName }

        t.b onClickChangeCC, '.emphasis-button', ->
          t.format 'enter-a-credit-card-to-activate-productname', { productName }



// WEBPACK FOOTER //
// ./app/scripts/views/billing/billing-component.coffee